"use client";
import react from "react";
const DropdownContext = /*#__PURE__*/ react.createContext({
    values: [],
    items: [],
    open: false,
    selectedItems: [],
    setOpen: ()=>{},
    setValues: ()=>{},
    setItems: ()=>{}
});
const useDropdownContext = ()=>{
    const context = react.useContext(DropdownContext);
    if (!context) throw new Error('Dropdown compound components cannot be rendered outside the Dropdown component');
    return context;
};
export { DropdownContext, useDropdownContext };
